var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
/*
 * The transition object encodes information about the type of transition
 * as well as the to/from location. It is passed to the guard function,
 * and can optionally be used a the return type of the guard as well, in
 * order to let the Scheduler know where to transition to next.
 */


export var NavigationTypes = {
  PUSH: 'PUSH',
  POP: 'POP',
  REPLACE: 'REPLACE',
  GO_BACK: 'GO_BACK'
};

var Navigation = function () {
  function Navigation(x) {
    _classCallCheck(this, Navigation);

    this.type = x.type;
    this.sequence = x.sequence || 0;
    this.to = x.to || null;
    this.from = x.from || null;
    this.shouldTransition = typeof x.shouldTransition === 'boolean' ? x.shouldTransition : this.sequence > 0;
  }

  _createClass(Navigation, [{
    key: 'next',
    value: function next(_next) {
      return new Navigation({
        type: _next.type,
        sequence: this.sequence + 1,
        from: this.to,
        to: _next.to
      });
    }
  }, {
    key: 'prev',
    value: function prev() {
      return new Navigation({
        type: NavigationTypes.GO_BACK,
        sequence: this.sequence + 1,
        from: this.to,
        to: null
      });
    }
  }, {
    key: 'redirectTo',
    value: function redirectTo(href) {
      var leaf = this.leaf;
      var to = asLocation(function () {
        if (typeof href === 'string') {
          var parentUrl = leaf ? leaf.parentUrl : '';
          var redirectUrl = href.startsWith('/') ? href : parentUrl + '/' + href;
          return redirectUrl;
        }

        return href;
      }());
      return Promise.reject(this.next({
        type: 'REPLACE',
        to: to
      }));
    }
  }, {
    key: 'raise',
    value: function raise(klass) {
      for (var _len = arguments.length, opts = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        opts[_key - 1] = arguments[_key];
      }

      return Promise.reject(new (Function.prototype.bind.apply(klass, [null].concat([this], _toConsumableArray(opts))))());
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      return Promise.reject(this.prev());
    }
  }]);

  return Navigation;
}();

Navigation.EMPTY = new Navigation({
  type: NavigationTypes.POP,
  to: null
});
export default Navigation;

function asLocation(href) {
  return typeof href === 'string' ? {
    pathname: href
  } : _extends({}, href);
}